export default __webpack_public_path__ + "static/2-de6529873ca89628fc3a4a3929f2e312.jpg";